// extracted by mini-css-extract-plugin
export default {"shell":"WlpThemeShell_shell__lbg6J"};